import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import SmsIcon from "@mui/icons-material/Sms";
import { Checkbox, Chip, ListItem, ListItemIcon, ListItemProps, ListItemText, Stack, Tooltip } from "@mui/material";
import React from "react";

import { EnhancedCenter } from "../../../../Models/Center";
import { CustomListItem } from "../../../Helpers/SelectList";

const CenterListItem: React.FC<CustomListItem<EnhancedCenter>> = ({ data: center, selected, ...rest }) => {
  delete rest["disableRipple"];
  delete rest["hideCheckBoxes"];
  return (
    <ListItem {...(rest as ListItemProps)} sx={{ minWidth: "28rem" }}>
      <ListItemIcon>
        <Checkbox edge="start" checked={selected} tabIndex={-1} />
      </ListItemIcon>
      <ListItemText primary={center.name} />
      <Stack direction="row" spacing={1}>
        {center.isActive && (
          <Chip
            size="small"
            label={
              <GemEnabledChipContent
                isDialable={EnhancedCenter.hasEnabledDialTime(center)}
                isTextable={center.isTextable}
              />
            }
          />
        )}
        {!center.isObxDisabled && <Chip size="small" label="OBX" />}
      </Stack>
    </ListItem>
  );
};

const GemEnabledChipContent: React.FC<{ isTextable: boolean; isDialable: boolean }> = ({ isDialable, isTextable }) => (
  <Stack direction="row" display="flex" alignItems="center" spacing={0.5}>
    <span>GEM</span>
    {isDialable && (
      <Tooltip title="Dialable">
        <PhoneEnabledIcon color="primary" fontSize="small" />
      </Tooltip>
    )}
    {isTextable && (
      <Tooltip title="Textable">
        <SmsIcon color="primary" fontSize="small" />
      </Tooltip>
    )}
  </Stack>
);

export default CenterListItem;
